module.exports = __webpack_public_path__ + "img/guests-limit.092ca99e.svg";